export default "__VITE_ASSET__aa7cb11e__"